// extracted by mini-css-extract-plugin
export default {"title":"MasterSaleDetails_title__kvE4Q","total":"MasterSaleDetails_total__8giRT","edit":"MasterSaleDetails_edit__RFfOu","cancel":"MasterSaleDetails_cancel__lrs7U"};